module.exports = __webpack_public_path__ + "static/media/mystyles.12a080e7.scss";


//////////////////
// WEBPACK FOOTER
// ./src/mystyles.scss
// module id = 249
// module chunks = 0